import React, { useState } from 'react';
import { UserCircle, Bell, LogOut, ChevronDown } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';

interface TopBarProps {
    onLogout?: () => void;
}

export const TopBar: React.FC<TopBarProps> = ({ onLogout }) => {
    const [userMenuOpen, setUserMenuOpen] = useState(false);

    return (
        <div className="h-16 px-6 flex items-center justify-between bg-gradient-to-b from-black/50 to-transparent backdrop-blur-sm z-50">
            <div className="flex items-center gap-3">
                <span className="text-xl font-bold tracking-tight text-white">
                    Weaver<span className="text-neon-gold drop-shadow-glow">BI</span>
                </span>
            </div>

            <div className="flex items-center gap-4">


                <div className="h-8 w-[1px] bg-white/10" />

                <div className="relative">
                    <button
                        onClick={() => setUserMenuOpen(!userMenuOpen)}
                        className="flex items-center gap-2 text-sm font-medium text-gray-300 hover:text-white transition-colors group"
                    >
                        <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center border border-white/10 group-hover:border-neon-gold/50 transition-colors">
                            <UserCircle size={20} />
                        </div>
                        <span>User</span>
                        <ChevronDown size={14} className={`transition-transform duration-200 ${userMenuOpen ? 'rotate-180' : ''}`} />
                    </button>

                    <AnimatePresence>
                        {userMenuOpen && (
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 10 }}
                                className="absolute right-0 top-full mt-2 w-48 bg-obsidian-900 border border-white/10 rounded-xl shadow-xl overflow-hidden z-50"
                            >
                                <div className="p-1">
                                    <button
                                        onClick={() => {
                                            setUserMenuOpen(false);
                                            onLogout?.();
                                        }}
                                        className="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-400 hover:bg-red-500/10 hover:text-red-300 rounded-lg transition-colors"
                                    >
                                        <LogOut size={16} />
                                        Logout
                                    </button>
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </div>
        </div>
    );
};
